/**
 * Utility function that mocks the `IntersectionObserver` API. Necessary for components that rely
 * on it, otherwise the tests will crash.
 *
 * Recommended to execute inside `beforeEach`.
 */

export const setupIntersectionObserverMock = () => {
  // IntersectionObserver isn't available in test environment
  const MockIntersectionObserver = jest.fn();
  MockIntersectionObserver.mockReturnValue({
    observe: () => null,
    unobserve: () => null,
    disconnect: () => null
  });

  Object.defineProperty(global, 'IntersectionObserver', {
    writable: true,
    configurable: true,
    value: MockIntersectionObserver
  });
};
